import React, { useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import AppointmentList from 'src/components/AppointmentList';
import AppointmentListHeader from 'src/components/AppointmentListHeader';
import { useGlobalContext } from 'src/context/GlobalContext';
import AppointmentTypeSelect from 'src/components/AppointentTypeSelect';
import PersonIcon from '@mui/icons-material/Person';
import PatientTypeToggle from 'src/components/PatientTypeToggle';
import { motion } from 'framer-motion';
import { useThemeContext } from 'src/context/ThemeContext';
import Notification from 'src/components/Notification';

const TypeSelectView = () => {

  const { 
    selectedType, 
    setSelectedType,
    practitioners,
    windowMovedBack,
    branch,
    errorMessage,
    setErrorMessage,
  } = useGlobalContext();

  const { secondaryColor } = useThemeContext();

  const handleChange = () => {
    setSelectedType({ID: ""});
  }

  useEffect(() => {
    setTimeout(() => {
      if(errorMessage) setErrorMessage('');
    }, 11000);
  }, [errorMessage, setErrorMessage]);

  return (
    <div className='view-wrapper' style={{position: "relative"}}>

      {errorMessage && <Notification message={errorMessage}/>}

      <div className='d-flex-center'>
        <PersonIcon sx={{fontSize: '50px', marginTop: '15px', marginRight: '10px'}}/> 
        <div className='booking-title'>Book an Appointment</div>
      </div>
      <motion.div 
        animate={{ height: (selectedType.ID) ? 0 : 'auto' }} 
        initial={{ height: windowMovedBack ? 0 : 'auto' }} 
        transition={{ ease: "easeInOut", duration: 0.5 }} 
        style={{overflow: 'hidden'}}
      >
        {branch && branch.client.useCategory && <PatientTypeToggle/>}
        <AppointmentTypeSelect/>
      </motion.div>
      {selectedType.ID && <div className='d-flex-center selected-appointment-type' style={{marginBottom: '20px'}}>
        <div className='selected-desc'>{selectedType.description}</div>
        <div className='selected-change' style={{color: secondaryColor}} onClick={handleChange}>Change</div>
      </div>}
      <motion.div 
        animate={{ height: (selectedType.ID) ? 'auto' : 0 }} 
        initial={{ height: windowMovedBack ? 'auto' : 0 }} 
        transition={{ ease: "easeInOut", duration: 0.3, delay: 1 }} 
        style={{ overflow: 'hidden'}}
      >
        {selectedType.ID && practitioners.length > 0 && <AppointmentListHeader/>}
        {selectedType.ID && practitioners.length > 0 && <AppointmentList/>}
        {selectedType.ID && !practitioners.length > 0 && <LinearProgress 
          sx={{ backgroundColor: 'lightgrey', '& .MuiLinearProgress-bar': { backgroundColor: secondaryColor } }}
        />}
      </motion.div>
    </div>
  );
} 

export default TypeSelectView;